// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***********************************************
Colors
***********************************************/
/***** Brand *****/
:root {
  /* Infinity brand colors */
  --color-brand: #e73389;
  --color-brand-dark: #af2769;
  --color-brand-light: #f29dc3;
  --color-brand-picker: #e73389;
  /* Infinity brand colors */
  --color-headerBg: #0a3749;
  --color-headerTxt: #ffffff;
  /* Infinity playback colors */
  --color-brandPlyr: #e73389;
  --color-brand-darkPlyr: #af2769;
  --color-brand-lightPlyr: #f29dc3;
  font-size: 14px;
}

/***** Infinity *****/
/***** Positive *****/
/***** Warning *****/
/***** Negative *****/
/***** Information *****/
/***** Royal *****/
/***** Sun *****/
/***** Slates *****/
/*slate*/
/*stone*/
/*silver*/
/***** Blacks *****/
/*black*/
/***** Grays *****/
/***** Brand greyout set *****/
/***** Brand greyout set *****/
.refresh-btn {
  height: 1.8rem;
  width: 2.8rem;
  margin-top: 8px;
  padding: 0;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
button.close {
  color: white;
  font-size: 2rem;
  opacity: unset;
}
.icon--size-m {
  width: 2.75em;
  height: 2.75em;
}
.infinity-toaster {
  background-color: rgb(76, 175, 80) !important;
  border-radius: 3px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  min-width: 45%;
  max-width: 100%;
  min-height: 80px;
  font-size: 15px;
}
.infinity-toaster-header {
  color: rgb(255, 255, 255);
  border: none;
  background-color: transparent;
  font-family: OpenSans-Regular, sans-serif;
  font-weight: normal;
  letter-spacing: 1px;
  line-height: 19px;
}
.infinity-toaster-body {
  margin-left: 48px;
  color: rgb(255, 255, 255);
  background-color: transparent;
  font-family: OpenSans-Regular, sans-serif;
  font-weight: normal;
  letter-spacing: 1px;
  line-height: 19px;
  padding-top: 0;
}
.b-toast {
  max-width: 100%;
}
.b-toaster.b-toaster-bottom-right .b-toaster-slot {
  max-width: 45%;
}
#infinity-loader-body {
  z-index: 1000;
  padding: 0;
  background: transparent;
  position: fixed;
  height: 100%;
  top: 0;
  left: 230px;
  right: 0;
}
#infinity-spinner-body {
  z-index: 10000;
  top: 50%;
  background: rgba(0, 0, 0, 0.7);
  width: 50px;
  height: 50px;
  border-radius: 5px;
  left: 48.6%;
  position: absolute;
}
#infinity-spinner-body #infinity-spinner {
  margin: 1.3rem;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #2196f3 !important;
  background-color: #2196f3;
}
.custom-switch.b-custom-control-lg .custom-control-label::before, .input-group-lg .custom-switch .custom-control-label::before {
  top: 0;
  height: 1.75rem;
  left: -4rem;
  width: 3.1875rem;
  border-radius: 3px;
  background: transparent;
  border-color: #adb5bd;
}
.custom-switch.b-custom-control-lg .custom-control-label::after, .input-group-lg .custom-switch .custom-control-label::after {
  top: 0;
  height: 1.75rem;
  right: 0;
  width: 1.7875rem;
  border-radius: 3px;
  background-size: 50% 50%;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  top: 0;
  border-radius: 3px;
  height: 1.75rem;
  right: 0;
  width: 1.7875rem;
  background-color: #3498db;
  transform: translateX(0);
}
.custom-switch.b-custom-control-lg .custom-control-input:checked ~ .custom-control-label::after, .input-group-lg .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(-1.375rem);
}
.show-deleted {
  padding: 5px;
  height: 5rem;
  background: rgb(255, 255, 255);
  border-radius: 3px;
  color: rgb(38, 52, 62);
  font-size: 1em;
  font-weight: 600;
  line-height: 17.4px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
}
.show-deleted.input {
  height: 1rem;
}
.show-deleted-label {
  align-self: center;
  font-size: 1em;
}
.card {
  padding: 1rem;
  background: rgb(255, 255, 255);
  border: none;
  border-radius: 3px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
}
.table {
  border-radius: 3px;
}
.table td {
  vertical-align: unset;
}
table td > span, table th > span {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
table td > span span, table th > span span {
  padding-right: 5px;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: transparent;
}
.table-striped > tbody > tr:nth-child(2n) > td, .table-striped > tbody > tr:nth-child(2n) > th {
  background-color: rgba(0, 0, 0, 0.05);
}
.checkbox-border {
  padding: 0.375rem 0.75rem 0.375rem 3rem;
  border: 1px solid #6c757d;
  border-radius: 0.25rem;
}
.upload-history-table {
  text-align: center;
}
.upload-history-table thead tr {
  border-radius: 0.25rem;
}
.upload-history-table thead tr th {
  background-image: none !important;
}
.upload-history-table thead tr th:first-child {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.upload-history-table thead tr th:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.ready-to-delete {
  text-decoration: line-through;
}
.deleted {
  text-decoration: line-through;
  pointer-events: none;
}
.modal-text {
  font-size: 1.2rem;
}
.modal-bg-tan {
  background-color: #ffedb0;
}
.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.icon--size-s {
  width: 1.25em;
  height: 1.25em;
}
.icon {
  flex-shrink: 0;
}
.table-popover {
  min-width: 251px;
  max-width: inherit;
}
.table-popover .arrow {
  margin: 0;
}
.table-popover .arrow::after {
  border-bottom-color: black;
  border-top-color: black;
}
.table-popover .popover-body {
  padding: 0;
  background: #1c1c1b;
  font-size: 14px;
}
.table-popover .popover-body .list-group .list-group-item + * {
  border-top: 1px solid #4a4a49 !important;
}
.table-popover .popover-body .list-group .list-group-item {
  cursor: pointer;
  color: #fff;
  border-top: 0;
  border-radius: 0;
  background: transparent;
  padding: 10px 20px 10px 10px;
}
.table-popover .popover-body .list-group .list-group-item:hover {
  background-color: rgba(125, 127, 129, 0.5);
}
.infinity-pagination .page-item span, .infinity-pagination .page-item button {
  border: none;
  border-radius: 0.25rem;
  margin: 0 0.25rem;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
